export type RouteSyncAction =
  | { type: 'load_chat', chatId: number }
  | { type: 'reset_conversation' }

export interface RouteSyncActionArgs {
  chatId: number | undefined
  isNewChatRoute: boolean
  isLandingRoute: boolean
  existingRouteChatId: number | undefined
}

export function getRouteSyncAction({
  chatId,
  isNewChatRoute,
  isLandingRoute,
  existingRouteChatId,
}: RouteSyncActionArgs): RouteSyncAction | undefined {
  if (isNewChatRoute) {
    return chatId !== undefined ? { type: 'reset_conversation' } : undefined
  }

  if (existingRouteChatId !== undefined && existingRouteChatId !== chatId) {
    return { type: 'load_chat', chatId: existingRouteChatId }
  }

  if (isLandingRoute && chatId !== undefined) {
    return { type: 'reset_conversation' }
  }

  return undefined
}
